import { render, staticRenderFns } from "./AddNewBank.vue?vue&type=template&id=0f136f37&scoped=true"
import script from "./AddNewBank.vue?vue&type=script&lang=js"
export * from "./AddNewBank.vue?vue&type=script&lang=js"
import style0 from "./AddNewBank.vue?vue&type=style&index=0&id=0f136f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f136f37",
  null
  
)

export default component.exports